import { render } from "./FormWrapper.vue?vue&type=template&id=b59ab1d6&scoped=true"
import script from "./FormWrapper.vue?vue&type=script&lang=ts"
export * from "./FormWrapper.vue?vue&type=script&lang=ts"

import "./FormWrapper.vue?vue&type=style&index=0&id=b59ab1d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b59ab1d6"

export default script